export default function TransactionsTab({ transactions }) {
  return (
    <div className="space-y-4" data-testid="transactions-tab">
      <div className="bg-white rounded-xl border border-border shadow-sm overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted/50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">Session</th>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">Plan</th>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">Amount</th>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">Status</th>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">Report</th>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">Date</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {transactions.length === 0 ? (
              <tr><td colSpan={6} className="px-4 py-8 text-center text-muted-foreground">No transactions yet</td></tr>
            ) : transactions.map(t => (
              <tr key={t.session_id} className="hover:bg-muted/30">
                <td className="px-4 py-3 font-mono text-xs">{t.session_id?.slice(0, 16)}...</td>
                <td className="px-4 py-3 font-medium">{t.plan_name}</td>
                <td className="px-4 py-3">€{t.amount}</td>
                <td className="px-4 py-3">
                  <span className={`text-xs px-2 py-0.5 rounded-full ${
                    t.payment_status === 'paid' ? 'bg-green-100 text-green-700' :
                    t.payment_status === 'initiated' ? 'bg-amber-100 text-amber-700' :
                    'bg-muted text-muted-foreground'
                  }`}>{t.payment_status}</span>
                </td>
                <td className="px-4 py-3 font-mono text-xs">{t.report_id?.slice(0, 8)}...</td>
                <td className="px-4 py-3 text-xs text-muted-foreground">{new Date(t.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
